import WasmController from "react-lib/frameworks/WasmController";
import moment from "moment";
import Cookies from "js-cookie";
import DirectCouponCheck from "issara-sdk/apis/DirectCouponCheck_apps_PRX";
import DirectCouponList from "issara-sdk/apis/DirectCouponList_apps_PRX";
import UserWithPatientDetail from "issara-sdk/apis/UserWithPatientDetail_users";
import V3PatientCouponCheckM from "issara-sdk/apis/V3PatientCouponCheckM";
import DiagRuleDetail from "issara-sdk/apis/DiagRuleDetail_apps_PRX";
import PatientPublishedDiagRuleList from "../issara-sdk/apis/PatientPublishedDiagRuleList_apps_PRX";
import DiagFormList from "../issara-sdk/apis/DiagFormList_apps_PRX";
import V3MedProgramsListView from "../issara-sdk/apis/V3MedProgramsListView_apps_PRX";
import CheckRequireDiagRuleView from "../issara-sdk/apis/CheckRequireDiagRuleView_apps_PRX";
import { PublishedDiagRuleDetail } from "../react-lib/apis/issara/apps/PRX/PublishedDiagRule";
import PrenameList from "../issara-sdk/apis/PrenameList_users"
import NationalityList from "../issara-sdk/apis/NationalityList_users"
import ProxyPatientCreateView from "../issara-sdk/apis/ProxyPatientCreateView_apps_PRX"
import V3PatientHospital from "../issara-sdk/apis/V3PatientHospitalListView_apis_PRXM"

const dummyForm = {
  id: 20,
  link: "/form/55/",
  name: "แบบประเมิน COVID-19 Vaccine (Moderna)",
  description: "",
  content:
    '{"0":{"id":0,"parent_id":null,"label":"กรุณาเลือกภาษา","condition":"first","text":"กรุณาเลือกภาษา (Please select a language)","type":"choices","level":0,"span":9},"1":{"parent_id":0,"label":"ไทย","condition":"ไทย","text":"คุณมีอายุกี่ปี","type":"choices","id":1,"level":1,"span":7},"2":{"parent_id":0,"label":"Eng","condition":"English","text":"How old are you?","type":"choices","id":2,"level":1,"span":7},"3":{"parent_id":1,"label":"น้อยกว่า 18 ปี","condition":"น้อยกว่า 18 ปี","text":"ไม่สามารถเข้ารับบริการนี้ได้ เนื่องจากผู้รับบริการต้องมีอายุ 18 ปีขึ้นไป","type":"end","id":3,"level":2,"span":0},"4":{"parent_id":1,"label":"18-79 ปี","condition":"18-79 ปี ","text":"คุณคือผู้ที่ไม่สามารถช่วยเหลือตัวเองได้ใช่หรือไม่","type":"choices","id":4,"level":2,"span":2},"5":{"parent_id":1,"label":"มากกว่า 80","condition":"มากกว่า 80","text":"การทำนัดสำหรับผู้ที่มีอายุมากกว่า 80 ปี หรือผู้ที่ไม่สามารถช่วยเหลือตัวเอง กรุณาโทร 1719 (local only)","type":"end","id":5,"level":2,"span":0},"6":{"parent_id":4,"label":"ช่วยเหลือตัวเองไม่ได้","condition":"ใช่ ช่วยเหลือตัวเองไม่ได้","text":"การทำนัดสำหรับผู้ที่มีอายุมากกว่า 80 ปี หรือผู้ที่ไม่สามารถช่วยเหลือตัวเอง กรุณาโทร 1719 (local only)","type":"end","id":6,"level":3,"span":0},"7":{"parent_id":4,"label":"ช่วยเหลือตัวเองได้","condition":"ไม่ใช่","text":"คุณกำลังตั้งครรภ์ใช่หรือไม่","type":"choices","id":7,"level":3,"span":2},"8":{"parent_id":7,"label":"ไม่ตั้งครรภ์","condition":"ไม่ใช่","text":"","type":"end","id":8,"level":4,"span":0,"extra_items":[{"tag":"0","label":"คุณเคยป่วยเป็น COVID-19 ใช่หรือไม่","type":"Select","nullOk":true,"default":"","options":["ใช่"," ไม่ใช่"],"page":"1"},{"tag":"0","label":"ระบุวันที่รู้ผลครั้งแรก","type":"Text","nullOk":true,"default":"","options":["ใช่"," ไม่ใช่"],"page":"9"},{"tag":"0","label":"คุณเคยได้รับวัคซีน COVID-19 มาแล้วกี่เข็ม","type":"Select","nullOk":true,"default":"","options":["ไม่เคย"," 1"," 2"," 3"," 4"],"page":"2"},{"tag":"0","label":"เข็มที่ 1","type":"Select","nullOk":true,"default":"Sinovac,Sinopharm,AstraZeneca,Pfizer,Johnson & Johnson,Moderna","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"ระบุวันที่ฉีด","type":"Text","nullOk":true,"default":"","page":"9"},{"tag":"0","label":"เข็มที่ 2","type":"Select","nullOk":true,"default":"","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"ระบุวันที่ฉีด","type":"Text","nullOk":true,"default":"","page":"9"},{"tag":"0","label":"เข็มที่ 3","type":"Select","nullOk":true,"default":"","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"ระบุวันที่ฉีด","type":"Text","nullOk":true,"default":"","page":"9"},{"tag":"0","label":"เข็มที่ 4","type":"Select","nullOk":true,"default":"","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"ระบุวันที่ฉีด","type":"Text","nullOk":true,"default":"","page":"9"}],"extra_intro":"กรุณากรอกข้อมูล","extra_submit":"เสร็จสิ้น"},"9":{"parent_id":7,"label":"ตั้งครรภ์","condition":"ใช่","text":"","type":"end","id":9,"level":4,"span":0,"extra_items":[{"tag":"0","label":"กรุณาระบุอายุครรภ์","type":"Select","nullOk":true,"default":"","options":["1 สัปดาห์"," 2 สัปดาห์"," 3 สัปดาห์"," 4 สัปดาห์"," 5 สัปดาห์"," 6 สัปดาห์"," 7 สัปดาห์"," 8 สัปดาห์"," 9 สัปดาห์"," 10 สัปดาห์"," 11 สัปดาห์"," มากกว่า 12 สัปดาห์"],"page":"8"},{"tag":"0","label":"คุณเคยป่วยเป็น COVID-19 ใช่หรือไม่","type":"Select","nullOk":true,"default":"","options":["ใช่"," ไม่ใช่"]},{"tag":"0","label":"ระบุวันที่รู้ผลครั้งแรก","type":"Text","nullOk":true,"default":"","options":["ใช่"," ไม่ใช่"],"page":"9"},{"tag":"0","label":"คุณเคยได้รับวัคซีน COVID-19 มาแล้วกี่เข็ม","type":"Select","nullOk":true,"default":"","options":["ไม่เคย"," 1"," 2"," 3"," 4"]},{"tag":"0","label":"เข็มที่ 1","type":"Select","nullOk":true,"default":"","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"ระบุวันที่ฉีด","type":"Text","nullOk":true,"default":"","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"เข็มที่ 2","type":"Select","nullOk":true,"default":"","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"ระบุวันที่ฉีด","type":"Text","nullOk":true,"default":"","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"เข็มที่ 3","type":"Select","nullOk":true,"default":"","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"ระบุวันที่ฉีด","type":"Text","nullOk":true,"default":"","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"],"page":"9"},{"tag":"0","label":"เข็มที่ 4","type":"Select","nullOk":true,"default":"","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"ระบุวันที่ฉีด","type":"Text","nullOk":true,"default":"","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"],"page":"9"}],"extra_intro":"กรุณากรอกข้อมูล","extra_submit":"เสร็จสิ้น"},"10":{"parent_id":2,"label":"less than 18 years","condition":"less than 18 years","text":"Can\'t access this service Because the service recipient must be 18 years of age or older.","type":"end","id":10,"level":2,"span":0},"13":{"parent_id":2,"label":"18-79 years","condition":"18-79 years","text":"Are you those who are unable to help themselves?","type":"choices","id":13,"level":2,"span":2},"17":{"parent_id":2,"label":"more than 80 years\\n","condition":"more than 80 years","text":"To make an appointment for those over 80 or who are unable to help themselves, please call 1719 (local only) or +662 310 3000\\n","type":"end","id":17,"level":2,"span":0},"18":{"parent_id":13,"label":"ช่วยเหลือตัวเองไม่ได้ (Eng)","condition":"Yes","text":"To make an appointment for those over 80 or who are unable to help themselves, please call 1719 (local only) or +662 310 3000\\n","type":"end","id":18,"level":3,"span":0},"19":{"parent_id":13,"label":"ช่วยเหลือตัวเองได้ (Eng)","condition":"No","text":"Are you pregnant?","type":"choices","id":19,"level":3,"span":2},"20":{"parent_id":19,"label":"ไม่ตั้งครรภ์ (eng)","condition":"No","text":"","type":"end","id":20,"level":4,"span":0,"extra_items":[{"tag":"0","label":"Have you ever been infected with COVID-19","type":"Select","nullOk":true,"default":"","options":["Yes"," No"]},{"tag":"0","label":"First result date","type":"Text","nullOk":true,"default":"","options":["Yes"," No"],"page":"9"},{"tag":"0","label":"How many doses of COVID-19 Vaccine have you got?","type":"Select","nullOk":true,"default":"","options":["None"," 1"," 2"," 3"," 4"]},{"tag":"0","label":"Dose 1","type":"Select","nullOk":true,"default":"Sinovac,Sinopharm,AstraZeneca,Pfizer,Johnson & Johnson,Moderna","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"injection date","type":"Text","nullOk":true,"default":"","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"Dose 2","type":"Select","nullOk":true,"default":"Sinovac,Sinopharm,AstraZeneca,Pfizer,Johnson & Johnson,Moderna","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"injection date","type":"Text","nullOk":true,"default":"","page":"9","options":[""]},{"tag":"0","label":"Dose 3","type":"Select","nullOk":true,"default":"","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"],"page":"9"},{"tag":"0","label":"injection date","type":"Text","nullOk":true,"default":"","page":"9"},{"tag":"0","label":"Dose 4","type":"Select","nullOk":true,"default":"","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"],"page":"9"},{"tag":"0","label":"injection date","type":"Text","nullOk":true,"default":"","page":"9"}],"extra_intro":"กรุณากรอกข้อมูล","extra_submit":"เสร็จสิ้น"},"21":{"parent_id":19,"label":"ตั้งครรภ์ (eng)","condition":"Yes","text":"","type":"end","id":21,"level":4,"span":0,"extra_items":[{"tag":"0","label":"Please specify gestational age","type":"Select","nullOk":true,"default":"","options":["1 Week"," 2 Weeks"," 3 Weeks"," 4 Weeks"," 5 Weeks"," 6 Weeks"," 7 Weeks"," 8 Weeks"," 9 Weeks"," 10 Weeks"," 11 Weeks"," more than 12 Weeks"],"page":"9"},{"tag":"0","label":"Have you ever been infected with COVID-19?","type":"Select","nullOk":true,"default":"","options":["Yes"," No"]},{"tag":"0","label":"First result date","type":"Text","nullOk":true,"default":"","options":["Yes"," No"],"page":"9"},{"tag":"0","label":"How many doses of COVID-19 Vaccine have you got?","type":"Select","nullOk":true,"default":"","options":["None"," 1"," 2"," 3"," 4"]},{"tag":"0","label":"Dose 1","type":"Select","nullOk":true,"default":"","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"injection date","type":"Text","nullOk":true,"default":""},{"tag":"0","label":"Dose 2","type":"Select","nullOk":true,"default":"","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"injection date","type":"Text","nullOk":true,"default":""},{"tag":"0","label":"Dose 3","type":"Select","nullOk":true,"default":"","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"injection date","type":"Text","nullOk":true,"default":"","page":"9"},{"tag":"0","label":"Dose 4","type":"Select","nullOk":true,"default":"","page":"9","options":["Sinovac","Sinopharm","AstraZeneca","Pfizer","Johnson & Johnson","Moderna"]},{"tag":"0","label":"injection date","type":"Text","nullOk":true,"default":"","page":"9"}],"extra_intro":"กรุณากรอกข้อมูล","extra_submit":"เสร็จสิ้น"}}',
  active: true,
  published: true,
  dirty: true,
  updated: "2021-10-21T13:12:39.673182Z",
  created: "2021-10-15T09:53:54.135986Z",
  code: null,
  classify: "[]",
  division: 1274,
  latest_published_diag_rule: 55,
};

export type State = {
  theme?: string;
  projectName?: string;
  device_id?: string | number;
  subscription?: any;
  apiToken?: string;
  userId?: string | number;
  language?: "en-US" | "th-TH";
  loggedin?: boolean;
  platform?: string;
  prenameList?: any[];
  nationalityList?: any[];

  // MasterData
  evaluateForm?: any;

  // Data
  myCouponList?: any[];
  patientDetail?: any;
  createPatientInfo?: any;
  stackRememberScroll?: any[];

  // Temp
  allMyCouponList?: any[];
  firstLoadingSuccess?: boolean;
  selectedCoupon?: any;
  // Loading
  loadingSearchCoupon?: boolean;
  loadingModalRedeem?: boolean;
  loadingNewPatient?: boolean;
  loadingMainCoupon?: boolean;

  // Error
  successMessage?: any;
  errorMessage?: any;
  openModCreateNewPatient?: {
    open: boolean;
    error: any;
  },
  // config_PRX_ENABLE_ECOUPON?: boolean;
};

export const StateInitial: State = {
  myCouponList: [],
  allMyCouponList: [],
  patientDetail: {},
  prenameList: [],
  nationalityList: [],
  firstLoadingSuccess: false,
  selectedCoupon: null,
  createPatientInfo: {},
  stackRememberScroll: [],

  loggedin: false,
  platform: "",

  evaluateForm: null,

  loadingSearchCoupon: false,
  loadingModalRedeem: false,
  loadingNewPatient: false,
  loadingMainCoupon: false,

  successMessage: null,
  errorMessage: null,
  openModCreateNewPatient: {
    open: false,
    error: null,
  },
  language: ["th", "th-TH", "th-th"].includes(
    Cookies.get("language") || navigator?.language?.split(/[-_]/)[0]
  )
    ? "th-TH"
    : "en-US",
};

export type Event =
  | { message: "DidMount"; params: {} }
  | { message: "DidUpdate"; params: {} }
  | {
    message: "handleGetListMyCoupon";
    params: { reverse: boolean; search: string; type: string; userId: any };
  }
  | {
    message: "handleFilterListMyCoupon";
    params: { reverse: boolean; search: string; type: string };
  }
  | {
    message: "handleClickRedeemCoupon";
    params: { search: any; history: any };
  }
  | { message: "handleSelectedCoupon"; params: { data: any } }
  | {
    message: "getCouponDetail";
    params: { orderNo: string; couponId: string; hospital: number };
  }
  | { message: "openCamera"; params: {} }
  | {
    message: "getPatientCouponCheck";
    params: { hospital: number; couponId: number };
  }
  | { message: "handleGetPatientDetail"; params: { userId: string | number } }
  | { message: "handleGetEvaluate"; params: { productCode?: any } }
  | {
    message: "handleSaveDiagForm";
    params: {
      answers?: any;
      patientId?: number | null;
      publishedId?: number | null;
    };
  }
  | { message: "GetLoginInfo"; params: {} }
  | { message: "GetMasterDataNewPatient"; params: {} }
  | {
    message: "HandleSetValueCreatePatient";
    params: { key: string; value: any };
  }
  | { message: "HandleCreateNewPatient"; params: { data: any; history: any; } }
  | { message: "HandleCloseModCreateNewPatient"; params: {} }
  | {
    message: "HandleRouteChange";
    params: { currentPathname: string; nextPathname: string; action: string };
  } | {
    message: "MakeAppointmentDubaiTeleConsult";
    params: { productCode: string; history: any };
  }
  // | { message: "GetConfigPrxEnableEcoupon", params: {} }

export type Data = {};

export const DataInitial = {};

type Handler = (
  controller: WasmController<State, Event, Data>,
  params?: any
) => any;

export const DidMount: Handler = async (controller, params) => { };

export const DidUpdate: Handler = async (controller, params) => { };

export const handleGetPatientDetail: Handler = async (controller, params) => {
  const [patientData, patientError] = await GetUserWithPatientDetail(
    controller,
    params
  );

  controller.setState({ patientDetail: patientData });
};

export const GetUserWithPatientDetail: Handler = async (controller, params) => {
  const [res, error] = await UserWithPatientDetail.retrieve({
    pk: params.userId || Cookies.get("userId"),
    apiToken: controller.apiToken || Cookies.get("apiToken"),
  });

  return [res, error];
};

export const handleGetListMyCoupon: Handler = async (controller, params) => {
  controller.setState({ loadingSearchCoupon: true });

  const [patientData, patientError] = await GetUserWithPatientDetail(
    controller,
    params
  );

  const [res, error] = await DirectCouponList.post({
    apiToken: controller.apiToken || Cookies.get("apiToken"),
    data: {
      phone: patientData?.phone_no,
    },
  });

  controller.setState({
    myCouponList: (res?.data || []).filter(
      (item: any) => item.coupon_status === "not use" && item.book_status
    ),
    allMyCouponList: [...(res?.data || [])],
    loadingSearchCoupon: false,
    patientDetail: patientData,
    firstLoadingSuccess: true,
  });
};

export const handleFilterListMyCoupon: Handler = async (controller, params) => {
  const { allMyCouponList } = controller.getState();
  let filterData = [...(allMyCouponList || [])];

  controller.setState({ loadingSearchCoupon: true });

  if (params.reverse) {
    filterData = filterData.reverse();
  }
  if (params.type) {
    filterData = filterData.filter(
      (item: any) => item.coupon_status === "not use" && item.book_status
    );
  }
  if (params.search) {
    filterData = filterData.filter(
      (item: any) =>
        item.product_name.toUpperCase().includes(params.search.toUpperCase()) ||
        item.coupon_id.includes(params.search)
    );
  }

  controller.setState({
    myCouponList: filterData,
    loadingSearchCoupon: false,
  });
};

export const handleClickRedeemCoupon: Handler = async (controller, params) => {
  controller.setState({ loadingModalRedeem: true });
  let { selectedCoupon } = controller.getState();
  const id = selectedCoupon?.id;

  const mapRedeem = (item: any) =>
    item.id === id
      ? { ...item, is_used: true, used_date: moment().format("YYYY-MM-DD") }
      : item;

  // const mockData = MOCK_DATA.map(mapRedeem)
  // const [res, error] = await new Promise((resolve, reject) => {
  //   MOCK_DATA = mockData
  //   setTimeout(() => resolve([mockData.find((item: any) => item.id === id), null]), 500);
  // })

  // controller.setState({
  //   selectedCoupon: res,
  //   loadingModalRedeem: false,
  // })
  // globalThis.location.replace(`?app=${"MobAppointment"}`);

  handleGetListMyCoupon(controller, params.search);
};

export const handleSelectedCoupon: Handler = async (controller, params) => {
  controller.setState({
    selectedCoupon: params.data,
  });
};

export const getCouponDetail: Handler = async (controller, params) => {
  const { orderNo, couponId } = params;
  controller.setState({ loadingSearchCoupon: true });

  const [resCheck, errCheck] = await getPatientCouponCheck(controller, params);

  if (errCheck) {
    controller.setState({ loadingSearchCoupon: false });
    return [resCheck, errCheck];
  }

  if (resCheck?.result_code !== "Y") {
    controller.setState({ loadingSearchCoupon: false });
    return [{ is_coupon_check: true }, resCheck?.result_details];
  }

  const [res, error] = await DirectCouponCheck.post({
    apiToken: controller.apiToken || Cookies.get("apiToken"),
    data: {
      order_no: orderNo,
      coupon_no: couponId,
    },
  });

  controller.setState({ loadingSearchCoupon: false });
  return [res, error];
};

export const handleGetEvaluate: Handler = async (controller, params) => {
  controller.setState({ loadingMainCoupon: true });
  const [resMedPro, errMedPro] = await V3MedProgramsListView.list({
    apiToken: controller.apiToken || Cookies.get("apiToken"),
    params: { p_code: params.productCode },
  });

  console.log("Get Med-porgram:", resMedPro);

  if (resMedPro && resMedPro.items?.length > 0 && (resMedPro.items[0]?.diag_rule && resMedPro.items[0]?.division)) {
    let selectedMedProgram = resMedPro.items[0];
    console.log("resMedPro");
    const [resCheckPub, errCheckPub] = await CheckRequireDiagRuleView.get({
      apiToken: controller.apiToken || Cookies.get("apiToken"),
      params: {
        diag_rule: selectedMedProgram.diag_rule
      },
    });
    console.log("resCheckPub:", resCheckPub);

    if (errCheckPub) {
      console.log("No med program");
      controller.setState({
        evaluateForm: dummyForm,
        loadingMainCoupon: false,
      });
      return;
    }

    const [resPub, errPub] = await PublishedDiagRuleDetail.retrieve({
      apiToken: controller.apiToken || Cookies.get("apiToken"),
      pk: resCheckPub.publish_diag_rule,
    });

    if (resPub && Object.keys(resPub).length > 0) {
      console.log("Response published diag rule:", resPub);
      controller.setState({
        evaluateForm: resPub,
        loadingMainCoupon: false,
      });
      return { medProgram: resMedPro, diagFormId: resCheckPub.diag_form };
    }
  }
  // const [resCheck, errCheck] = await DiagRuleDetail.retrieve({
  //   apiToken: controller.apiToken || Cookies.get("apiToken"),
  //   pk: parseInt(params.diagrule),
  // });

  // if (errCheck) {
  //   const [resPub, errPub] = await PatientPublishedDiagRuleList.list({
  //     apiToken: controller.apiToken || Cookies.get("apiToken"),
  //   });
  //   if (resPub && Object.keys(resPub).length > 0 && resPub?.items?.length > 0) {
  //     let evaluateForm = resPub.items.find(
  //       (item) => item.diag_rule === parseInt(params.diagrule)
  //     );

  //     if (evaluateForm && Object.keys(evaluateForm).length > 0) {
  //       console.log("filter items:", evaluateForm);
  //       controller.setState({
  //         evaluateForm: evaluateForm,
  //         loadingSearchCoupon: false,
  //       });
  //       return;
  //     }
  //   }
  // }

  // prepare set item here soon this code will apply dummy form to any coupon product
  controller.setState({ evaluateForm: dummyForm, loadingMainCoupon: false });
  // controller.setState({ evaluateForm: {}, loadingSearchCoupon: false });
  return { medProgram: resMedPro };
};

export const getPatientCouponCheck: Handler = async (controller, params) => {
  const [resCheck, errCheck] = await V3PatientCouponCheckM.get({
    apiToken: controller.apiToken || Cookies.get("apiToken"),
    params: {
      hospital: params.hospital,
      coupon: params.couponId,
    },
  });
  // controller.setState({ loadingMainAppointment: false })
  return [resCheck, errCheck];
};

export const handleSaveDiagForm: Handler = async (controller, params) => {
  console.log("handleSaveDiagForm", params);
  controller.setState({ loadingSearchCoupon: true });

  const [resSaveDiag, errorSaveDiag] = await DiagFormList.create({
    apiToken: controller.apiToken || Cookies.get("apiToken"),
    data: {
      answers: JSON.stringify(params.answers),
      finished: true,
      patient: params.patientId,
      published_diag_rule: params.publishedId,
    },
  });
  if (errorSaveDiag) {
    console.log("handleSaveDiagForm error", errorSaveDiag);
  }

  controller.setState({ loadingSearchCoupon: false });
  // return;
};


export const GetPrename: Handler = async (controller, params) => {

  let lang = undefined
  if (globalThis.window.mobile.iOSLang) {
    lang = globalThis.window.navigator.language
  }

  const [res, error, net] = await PrenameList.list({
    apiToken: Cookies.get("apiToken"),
    ...(lang && { extra: { headers: { 'Accept-Language': lang } } })
  });

  return [res, error, net]
};

export const GetNationality: Handler = async (controller, params) => {

  let lang = undefined
  if (globalThis.window.mobile.iOSLang) {
    lang = globalThis.window.navigator.language
  }

  const [res, error, net] = await NationalityList.list({
    apiToken: Cookies.get("apiToken"),
    ...(lang && { extra: { headers: { 'Accept-Language': lang } } })
  });

  return [res, error, net]
};

export const GetMasterDataNewPatient: Handler = async (controller, params) => {
  controller.setState({ loadingNewPatient: true })

  const response = await Promise.all([GetPrename(controller), GetNationality(controller)])
  const [prename, nationality] = response

  controller.setState({
    prenameList: prename?.[0]?.items || [],
    nationalityList: nationality?.[0]?.items || [],
    loadingNewPatient: false
  })
}


export const HandleSetValueCreatePatient: Handler = (controller, params) => {
  const { createPatientInfo } = controller.getState();
  const { key, value } = params;

  if (createPatientInfo) {
    if (key === "phone_no" && value?.length > 10) {
      return
    }
    createPatientInfo[key] = value;

    controller.setState({
      createPatientInfo: { ...createPatientInfo },
    });
  }

};

export const HandleCreateNewPatient: Handler = async (controller, params) => {
  const { createPatientInfo } = controller.getState()
  controller.setState({ loadingNewPatient: true })

  const { data, history } = params
  if (data.birthdate) {
    data.birthdate = moment(data.birthdate).format("YYYY-MM-DD")
  }

  if (data.phone_no && data.phone_no.length !== 10 && Object.keys(createPatientInfo || {}).length === 8) {
    const language = ["th", "th-TH", "th-th"].includes(navigator?.language?.split(/[-_]/)[0])
      ? "th-TH"
      : "en-US"
    const phoneError = {
      "th-TH": "กรุณากรอกหมายเลขโทรศัพท์ให้ครบ 10 หลัก",
      "en-US": "Please enter your phone number to complete 10 digits."
    }[language]
    controller.setState({
      loadingNewPatient: false,
      openModCreateNewPatient: { open: true, error: { phone_no: [phoneError] } }
    })
    return
  }

  const [res, error] = await ProxyPatientCreateView.create({
    apiToken: Cookies.get("apiToken"),
    data
  })

  controller.setState({ loadingNewPatient: false })

  if (error) {
    controller.setState({ openModCreateNewPatient: { open: true, error } })
    return
  }
  controller.setState({ openModCreateNewPatient: { open: false, error: null } })

  history.push({
    pathname: `/evaluate/?app=${"MobCoupon"}`,
    state: {
      ...history.location.state,
      book_for_some_else: true,
      patientForSomeElse: {
        ...(res || {}),
        gender: ({ M: 1, F: 2 } as any)[res?.gender || ""]
      }
    },
  });

}

export const HandleCloseModCreateNewPatient: Handler = (controller, params) => {
  controller.setState({ openModCreateNewPatient: { open: false, error: null } })

}

export const MakeAppointmentDubaiTeleConsult: Handler = async (controller, params) => {
  controller.setState({ loadingSearchCoupon: true })
  let [res, error] = await V3MedProgramsListView.list({
    apiToken: controller.apiToken || Cookies.get("apiToken"),
    params: { p_code: params.productCode },
  });

  controller.setState({ loadingSearchCoupon: false })

  if (error) {
    controller.setState({ openModCreateNewPatient: { open: true, error } })
    return
  }
  controller.setState({ openModCreateNewPatient: { open: false, error: null } })

  const { patientDetail
  } = controller.getState()
  const detail = res?.items?.[0] || {}

  params.history.push({
    pathname: `/select-date/${detail.location_code}/?app=${"MobAppointment"}`,
    state: {
      patientDetail,
      hospitalDetail: {
        id: detail.hospital_id,
        name: "Bangkok Hospital (BHQ)"
      },
      service: detail.service,
      place: detail.place,
      doctor_code: detail.doctor_code,
      med_program: detail.id,
      doctor: detail.doctor,
      division: detail.division,
      booking_service_code: detail.booking_service_code,
      appointment_type: "check_up",
      check_up_image: detail.image || detail.image_url,
      product_name: detail.name,
      is_telemed: detail.is_telemed,
      add_coupon: true,
      dubai_tele_consult: true
    },
  });
  params.history.go();
}